import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './PageLayout.scss';
import { createMedia } from '@artsy/fresnel';
import { actions } from '../../security/modules/actionsAuth';
import DesktopPageLayout from './components/DesktopPageLayout';
import MobilePageLayout from './components/MobilePageLayout';

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

const PageLayout = ({ children, auth, authenticationLogout }) => (
  <MediaContextProvider>
    <DesktopPageLayout auth={auth} authenticationLogout={authenticationLogout} Media={Media}>
      {children}
    </DesktopPageLayout>
    <MobilePageLayout auth={auth} authenticationLogout={authenticationLogout} Media={Media}>
      {children}
    </MobilePageLayout>
  </MediaContextProvider>
);

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  auth: PropTypes.any.isRequired.isRequired,
  authenticationLogout: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  authenticationLogin: actions.authenticationLogin,
  authenticationLogout: actions.authenticationLogout,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout);



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js